import moment from 'moment'
import { API } from '@/models/core'
import { Schedule } from '@/models/schedule'
import { CricketMatch } from './match'
import { CricketPlayer } from './player'

export class CricketSeasonRound {
  static createFromJson (raw) {
    let matches = []
    raw.matches.forEach((matchRaw) => {
      matchRaw.teams = raw.teams
      // const match = FootballMatch.createFromJson({ match: matchRaw, teams: raw.teams })
      // matches.push(match)
      matches.push(CricketMatch.createFromJson(matchRaw))
    })
    raw.matches = matches
    let round = new CricketSeasonRound()
    round = Object.assign(round, raw)
    return round
  }
}

export class CricketSeason {
  get matchDays () {
    let endDate = this.endDate

    if (!this.endDate && this.matchKeys.length > 0) {
      const lastMatchKey = this.matchKeys[this.matchKeys.length - 1]
      endDate = this.matches[lastMatchKey].possibleCompleteDate
    }

    if (!this.startDate || this.startDate > endDate) {
      console.log('Invalid Start or End date', this.startDate, endDate)
    }

    let dates = []
    let startDate = this.startDate.clone()
    let count = 0
    while (count < 365 && startDate.isSameOrBefore(endDate, 'days')) {
      dates.push(startDate.clone())
      startDate = startDate.add(1, 'days')
      count++
    }

    return dates
  }

  static createFromJson (raw) {
    let season = new CricketSeason()
    season = Object.assign(season, raw)
    season.startDate = moment(season.start_date.iso)
    if (season.end_date) {
      season.endDate = moment(season.end_date.iso)
    }

    if (season.rounds_info) {
      season.rounds_info.reverse()
    }

    let matchKeys = []
    if (season.matches) {
      Object.keys(season.matches).forEach((matchKey) => {
        const matchRaw = season.matches[matchKey]
        season.matches[matchKey] = CricketMatch.createFromJson(matchRaw)
        matchKeys.push(matchKey)
      })

      matchKeys.sort((x, y) => {
        const matchA = season.matches[x]
        const matchB = season.matches[y]
        if (matchA.start_at.isAfter(matchB.start_at)) {
          return 1
        }
        return -1
      })
    }

    season.matchKeys = matchKeys

    if (season.teams) {
      const teamKeys = Object.keys(season.teams).sort((x, y) => {
        if (season.teams[x].name > season.teams[y].name) {
          return 1
        }
        return -1
      })

      Object.keys(season.rounds).forEach((roundKey) => {
        const round = season.rounds[roundKey]
        const groupKeys = Object.keys(round.groups).sort((x, y) => {
          if (round.groups[x].matches.length > 0 && round.groups[y].matches.length > 0 && season.matches) {
            const matchX = season.matches[round.groups[x].matches[0]]
            const matchY = season.matches[round.groups[y].matches[0]]
            if (matchX.start_at > matchY.start_at) {
              return 1
            }
          }
          return -1
        })

        round.groupKeys = groupKeys
      })

      season.teamKeys = teamKeys
    }
    return season
  }

  static schedule (key, monthKey, isMetric) {
    let url
    if (isMetric) {
      url = `/cricket/v4/season/${key}/schedule/`
    } else {
      url = `/cricket/season/${key}/schedule/`
    }
    return API.instance().get(url).then((resp) => {
      const months = resp.data.data.schedule
      let monthResponse = null
      let monthIndex = -1
      let prevMonth5Days = null
      let raw = {}

      if (!monthKey) {
        monthKey = moment().format('YYYY-MM')
      }

      months.forEach((monthRaw, i) => {
        if (monthRaw.month === monthKey) {
          monthResponse = monthRaw
          monthIndex = i
        }
      })

      if (monthIndex > 0) {
        prevMonth5Days = months[monthIndex - 1]
        raw.cricket_prev_5days = { months: [prevMonth5Days] }
      }

      if (!monthResponse) {
        monthResponse = months[0]
        monthKey = monthResponse.month
      }

      raw.cricket = { months: [monthResponse] }

      return Schedule.createFromJson(raw, null, monthKey)
    })
  }

  static fetchPoints (key, isMetric) {
    let url
    if (isMetric) {
      url = `/cricket/v4/season/${key}/points/`
    } else {
      url = `/cricket/season/${key}/points/`
    }
    return API.instance().get(url).then((resp) => {
      const raw = resp.data.data
      return raw.points
    })
  }

  static team (key, teamKey, isMetric) {
    let url
    if (isMetric) {
      url = `/cricket/v4/season/${key}/team/${teamKey}/`
    } else {
      url = `/cricket/season/${key}/team/${teamKey}/`
    }
    return API.instance().get(url).then((resp) => {
      console.log('url', url)
      const raw = resp.data.data
      const team = raw.team
      Object.keys(team.players).forEach((key) => {
        team.players[key] = CricketPlayer.createFromJson(key, team.players[key])
      })
      return team
    })
  }

  static fetchStatsWithSeason (key, isMetric) {
    let url
    if (isMetric) {
      url = `/cricket/v4/season/${key}/stats/`
    } else {
      url = `/cricket/season/${key}/stats/`
    }
    return this.fetch(key).then((season) => {
      return API.instance().get(url).then((resp) => {
        const stats = resp.data.data.stats
        return { season, stats }
      })
    })
  }

  static fetch (key, isMetric) {
    let url
    if (isMetric) {
      url = `/cricket/v4/season/${key}/`
    } else {
      url = `/cricket/season/${key}/`
    }
    return API.instance().get(url).then((resp) => {
      const raw = resp.data.data
      const season = CricketSeason.createFromJson(raw.season)
      return season
    })
  }
}
